import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProductService } from 'app/services/product/product.service';
import { Router } from '@angular/router';
import { ProductDataDto } from 'app/models/product-data-dto';
import { debounceTime, Subject } from 'rxjs';
import { ProductPickerModalComponent } from '../../productSearch/product-picker-modal/product-picker-modal.component';
import { ImageFallbackDirective } from "app/modules/admin/directives/ImageFallbackDirective";
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';



@Component({
  selector: 'app-reservations',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, ProductPickerModalComponent, ImageFallbackDirective,ImageUrlPipe],
  templateUrl: './reservations.component.html',
  styleUrls: ['./reservations.component.scss']
})
export class ReservationsComponent implements OnInit {

 
  private saveSubject = new Subject<any>();
  showStockModal = false;
  showProductsModal = false;


  products: ProductDataDto[] = [];
  filteredProducts: ProductDataDto[] = [];
  selectedProduct: ProductDataDto = null;

  // Pagination properties
  currentPage: number = 1;
  itemsPerPage: number = 8;
  totalItems: number = 0;
  totalPages: number = 0;
  isLoading: boolean = false;

  // Search state
  isSearching: boolean = false;
  searchTerm: string = '';

pickerOpen = false;

onPickerSaved(rows: Array<{ product_id: number; value: number }>) {
  const payload: {
    day: number;
    items: Array<{ product_id: number; value: number }>;
  } = {
    day: 0,
    items: rows
  };

  // هنا تقدر تبعت rows للـ API أو تحطها في جدول خارجي
  this.productService.updateProductType(payload).subscribe({
    next:(res:any)=>{console.log(res);if (res.success) {
      this.loadPage(1);
    }}
  });
}


  constructor(
    private productService: ProductService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.saveSubject.pipe(debounceTime(500)).subscribe((item) => {
      this.saveRow(item);
    });
  }


  ngOnInit() {
    this.loadPage(1);
  }
//////////////////////////////////////////////

stockErrors: boolean[] = [];

validateStock(): boolean {
  this.stockErrors = []; // تأكد أن stockErrors معرف كـ boolean[] = [];
  const inputElements = this.stockQtyInputs.toArray();
  let isValid = true;

  if (!this.selectedProduct?.stock) return false;

  for (let i = 0; i < this.selectedProduct.stock.length; i++) {
    const stk = this.selectedProduct.stock[i];
    const inputEl = inputElements[i]?.nativeElement as HTMLInputElement;

    if (inputEl) {
      const stockedValue = parseFloat(inputEl.value) || 0;
      const allocated = stk.alloc_qty || 0;

      if (stockedValue < allocated) {
        this.stockErrors[i] = true;
        isValid = false;
      } else {
        this.stockErrors[i] = false;
      }
    }
  }

  return isValid;
}
////////////////////////////////////////////// 

markDirty(item: any) {
    item._dirty = true;
  }
   onQtyChange(item: any) {
    // (اختياري) Validation سريع
    item.min_qty = Number(item.min_qty ?? 0);
    item.prod_qty = Number(item.prod_qty ?? 0);
    item.max_qty = Number(item.max_qty ?? 0);

    // مثال: خلي max >= min
    if (item.max_qty < item.min_qty) item.max_qty = item.min_qty;

    this.saveSubject.next(item);
  }

  saveRow(item: any) {
    const payload = {
      id: item.id,
      min_qty: item.min_qty,
      prod_qty: item.prod_qty,
      max_qty: item.max_qty,
    };
console.log(payload);
    this.productService.updateProductQty(payload).subscribe({
      next: () => {
        item._dirty = false;
        this.loadPage(1);
      },
      error: (err) => {
        this.loadPage(1);
        
        console.error(err);
        // هنا تقدر تعرض Toast "فشل الحفظ"
      }
    });
  }
  transferProduct(item:any)
  {
    console.log(item);
  }
openStockModal(product: any) {
  // Clone عشان لو Cancel مايحفظش
  this.selectedProduct = JSON.parse(JSON.stringify(product));
  this.showStockModal = true;
  console.log(product);
}

closeStockModal() {
  this.showStockModal = false;
  this.selectedProduct = null;
}
  

@ViewChildren('stock_qty', { read: ElementRef }) stockQtyInputs!: QueryList<ElementRef>;
saveStock() {
  if (!this.validateStock()) {
    return;
  }

  const inputElements = this.stockQtyInputs.toArray();
  const stockPayload = [];

  for (let i = 0; i < this.selectedProduct.stock.length; i++) {
    const stk = this.selectedProduct.stock[i];
    const inputEl = inputElements[i]?.nativeElement as HTMLInputElement;

    // اقرأ القيمة من الـ input (حتى لو نفس alloc_qty)
    const stock_qty = inputEl ? (parseFloat(inputEl.value) || 0) : stk.alloc_qty;

    stockPayload.push({
      id: stk.id,
      alloc_qty: stk.alloc_qty,   // القيمة المعدّلة من allocated input (لو سمحنا بتعديلها)
      stock_qty: stock_qty        // القيمة من stocked input
    });
  }

  const payload = {
    product_id: this.selectedProduct.id,
    stock: stockPayload
  };

  console.log('Payload:', payload);

  // API CALL
  this.productService.updateProductStock(payload.product_id, payload).subscribe({
    next: (res: any) => {
      console.log('Success:', res);
      this.loadPage(1);
      this.closeStockModal();
    },
    error: (err) => {
      console.error('Error saving stock:', err);
    }
  });
}
clearError(index: number) {
  delete this.stockErrors[index];
}
  /** مرن مع اختلاف أسماء meta من الـ backend */
  private setMeta(res: any) {
    const meta = res?.meta ?? {};

    const total =
      meta.total ??
      meta.Total ??
      0;

    const lastPage =
      meta.lastPage ??
      meta.last_page ??
      meta.lastpage ??
      meta.totalPages ??
      meta.total_pages ??
      meta.pages ??
      0;

    this.totalItems = Number(total) || 0;

    // لو lastPage مش موجود، احسبه من total / perPage
    const computed = Math.ceil((this.totalItems || 0) / (this.itemsPerPage || 1)) || 1;
    this.totalPages = Number(lastPage) || computed;
  }

  loadPage(page: number) {
    if (this.isLoading) return;

    this.isLoading = true;
    this.currentPage = page;

    // 👇 لو في Search خلي الـ pagination يكمل searchProducts
    const request$ = (this.isSearching && this.searchTerm)
      ? this.productService.searchReservationProducts(this.searchTerm, page, this.itemsPerPage,0)
      : this.productService.getReservationProducts(page);

    request$.subscribe({
      next: (res: any) => {
        this.products = res?.data ?? [];
        console.log(res);
        this.filteredProducts = [...this.products];

        this.setMeta(res);

        this.isLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });

        console.log(res);
        console.log(
          `Loaded page ${page} | items: ${this.products.length} | totalPages: ${this.totalPages} | searching: ${this.isSearching}`
        );
      },
      error: (err) => {
        console.error('Error loading products:', err);
        this.isLoading = false;
      }
    });
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.loadPage(page);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.loadPage(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.loadPage(this.currentPage + 1);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisiblePages = 5;

    // حماية لو totalPages لسه 0
    const safeTotalPages = this.totalPages || 1;

    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(safeTotalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) pages.push(i);
    return pages;
  }

  onItemsPerPageChange(event: any) {
    const newItemsPerPage = parseInt(event.target.value, 10);

    if (!Number.isFinite(newItemsPerPage) || newItemsPerPage <= 0) return;

    if (newItemsPerPage !== this.itemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.currentPage = 1;
      this.loadPage(1);
    }
  }

  getStartIndex(): number {
    if (this.totalItems === 0) return 0;
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    const end = this.currentPage * this.itemsPerPage;
    return Math.min(end, this.totalItems);
  }

  toggleProductSelection(product: ProductDataDto) {
    if (this.selectedProduct?.id === product.id) {
      this.selectedProduct = null;
    } else {
      this.selectedProduct = product;
    }
  }

  closeEditForm() {
    this.selectedProduct = null;
  }

  getCategoryName(category: any): string {
    return category?.categoryTranslations?.[0]?.name || category?.name || 'N/A';
  }

  getBrandName(brand: any): string {
    return brand?.brandTranslations?.[0]?.name || brand?.name || 'N/A';
  }

  getStoreName(store: any): string {
    return store?.storeTranslations?.[0]?.name || store?.name || 'Unknown Store';
  }

  getTotalStock(stock: any[]): number {
    return stock?.reduce((total, item) => total + (item.qty || 0), 0) || 0;
  }

  onSearch(event: any) {
    const term = (event.target.value || '').trim();

    // لو فاضي: ارجع للوضع العادي
    if (!term) {
      this.isSearching = false;
      this.searchTerm = '';
      this.currentPage = 1;
      this.loadPage(1);
      return;
    }

    // فعل وضع البحث
    this.isSearching = true;
    this.searchTerm = this.normalizeArabicText(term.toLowerCase());
    this.currentPage = 1;

    // استخدم نفس loadPage علشان الـ pagination يكمل search
    this.loadPage(1);
  }

  private normalizeArabicText(text: string): string {
    return text
      .replace(/[أآإ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/[ى]/g, 'ي')
      .replace(/[ؤ]/g, 'و')
      .replace(/[ئ]/g, 'ي');
  }

  handleImageError(event: any) {
    event.target.src = 'assets/images/logo/logo.svg';
  }

  editProduct(product: ProductDataDto) {
    alert('admin/edit-product/' + product.slug);
    this.router.navigateByUrl('admin/edit-product/' + product.slug);
  }

  deleteProduct(product: ProductDataDto) {
    if (!product) return;

    const message = `🗑️ Are you sure you want to delete "${product.name}"?\nThis action cannot be undone.`;
    const confirmed = confirm(message);
    if (!confirmed) return;

    this.productService.deleteProduct(product.id).subscribe({
      next: () => {
        this.loadPage(this.currentPage);
        alert('✅ Product deleted successfully');
      },
      error: (err) => {
        console.error('❌ Error deleting product:', err);
        alert('⚠️ Failed to delete product. Please try again.');
      }
    });
  }




}
